import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { Button } from "../ui/button";

import "swiper/css";
import "swiper/css/navigation";

const timeOptions = [
  { minutes: 15, label: "+15 min" },
  { minutes: 30, label: "+30 min" },
  { minutes: 45, label: "+45 min" },
  { minutes: 60, label: "+60 min" },
  { minutes: 90, label: "+90 min" },
];

export default function OnlineOrderTimeSwiper({
  onSelect,
}: {
  onSelect: (minutes: number) => void;
}) {
  const [selectedTime, setSelectedTime] = useState<number | null>(null);
  return (
    <div className="relative w-full flex justify-center gap-2">
      <Button
        variant="ghost"
        className="swiper-prev p-0 h-auto w-14 rounded-none flex items-center justify-center"
      >
        <ChevronLeft size={40} />
      </Button>

      <div className="relative w-[600px]">
        <div className="bg-card rounded-lg p-2 shadow-sm border">
          <Swiper
            modules={[Navigation]}
            spaceBetween={10}
            slidesPerView={3}
            initialSlide={1}
            navigation={{
              prevEl: ".swiper-prev",
              nextEl: ".swiper-next",
            }}
            className="w-full"
          >
            {timeOptions.map((option) => (
              <SwiperSlide key={option.minutes}>
                <Button
                  onClick={() => {
                    onSelect(option.minutes);
                    setSelectedTime(option.minutes);
                  }}
                  variant={selectedTime === option.minutes ? "brand" : "outline"}
                  className="w-full h-24 flex flex-col items-center justify-center gap-1"
                >
                  <span className="text-xl">{option.label}</span>
                </Button>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <Button
        variant="ghost"
        className="swiper-next h-auto w-14 rounded-none flex p-0 items-center justify-center"
      >
        <ChevronRight size={40} />
      </Button>
    </div>
  );
}
